import styled from "styled-components";

export const StyledRequired = styled.small`
  color: #ff5151;
`;

